<a class="text-primary" [routerLink]="_routerLink" [queryParams]="_queryParams">
  <ng-content></ng-content>
</a>
